import { render, staticRenderFns } from "./FormAuthorityConfig.vue?vue&type=template&id=45d6055c&scoped=true&"
import script from "./FormAuthorityConfig.vue?vue&type=script&lang=js&"
export * from "./FormAuthorityConfig.vue?vue&type=script&lang=js&"
import style0 from "./FormAuthorityConfig.vue?vue&type=style&index=0&id=45d6055c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d6055c",
  null
  
)

export default component.exports